module.exports = __webpack_public_path__ + "img/projects-3.0a2caeb1.jpg";